module.exports = __webpack_public_path__ + "static/media/Bumppy_Payment_logo.0e5c3206.svg";